<template>
	<div id="topCenter">
		<dv-border-box-8>
			<div class="chartBox">
				<div id="china_map" style="width: 100%;height: 100%;"></div>
				<div class="leftTop">
					<p>数据范围：全国</p>
					<p>截止时间：{{ currtime }}</p>
					<!-- <p class="myself">累计节能：<countTo :val="endVal"></countTo><span style="font-size: 15px;">KWH</span></p> -->
					<div class="number">
						<ul class="showtext">累计节能：</ul>
						<ul id="dataNums">
							<li v-for="(item,index) in list" :key="index">
								<div class="dataBoc">
									<div class="tt"
										:style="{transition:'all 2.5s ease-in-out 0s',top:'-'+item.top+'px'}">
										<span v-for="(item2,index2) in numList" :key="index2">{{item2}}</span>
									</div>
								</div>
							</li>
						</ul>
						<ul class="showtext"> KWH</ul>
					</div>
					<div v-if="!echartsType" @click='draw()' class="exicon mt-3">
						<i class="el-icon-d-arrow-left"></i>
					</div>
				</div>
				<div class="leftBottom" v-if="mapType">
					<div>
						<div class="float-l">
							<img src="../../assets/icon/xingxing.png">
						</div>
						<div class="float-l ml-2">
							<p>运营中心（2）</p>
						</div>
					</div>
					<div>
						<div class="float-l">
							<img src="../../assets/icon/dibiao.png">
						</div>
						<div class="float-l ml-2">
							<p>办事处（11）</p>
						</div>
					</div>
				</div>
				<div class="rightTop">
					<div class="float-l" :class="mapType ? 'selectDiv' : ''" @click="changeType(true)">
						<img v-if="mapType" src="../../assets/icon/shenjing2.png">
						<img v-else src="../../assets/icon/shenjing.png">
						<span class="ml-2">服务网络</span>
					</div>
					<div class="float-l ml-3" :class="!mapType ? 'selectDiv' : ''" @click="changeType(false)">
						<img v-if="mapType" src="../../assets/icon/diandiandian.png">
						<img v-else src="../../assets/icon/diandiandian2.png">
						<span class="ml-2">仓库分布</span>
					</div>
				</div>
			</div>
		</dv-border-box-8>
	</div>
</template>

<script>
	import '../../../node_modules/echarts/map/js/china.js';
	import '../../../node_modules/echarts/map/js/province/anhui.js';
	import '../../../node_modules/echarts/map/js/province/aomen.js';
	import '../../../node_modules/echarts/map/js/province/beijing.js';
	import '../../../node_modules/echarts/map/js/province/chongqing.js';
	import '../../../node_modules/echarts/map/js/province/fujian.js';
	import '../../../node_modules/echarts/map/js/province/gansu.js';
	import '../../../node_modules/echarts/map/js/province/guangdong.js';
	import '../../../node_modules/echarts/map/js/province/guangxi.js';
	import '../../../node_modules/echarts/map/js/province/guizhou.js';
	import '../../../node_modules/echarts/map/js/province/hainan.js';
	import '../../../node_modules/echarts/map/js/province/hebei.js';
	import '../../../node_modules/echarts/map/js/province/heilongjiang.js';
	import '../../../node_modules/echarts/map/js/province/henan.js';
	import '../../../node_modules/echarts/map/js/province/hunan.js';
	import '../../../node_modules/echarts/map/js/province/hubei.js';
	import '../../../node_modules/echarts/map/js/province/jiangsu.js';
	import '../../../node_modules/echarts/map/js/province/jiangxi.js';
	import '../../../node_modules/echarts/map/js/province/jilin.js';
	import '../../../node_modules/echarts/map/js/province/liaoning.js';
	import '../../../node_modules/echarts/map/js/province/neimenggu.js';
	import '../../../node_modules/echarts/map/js/province/ningxia.js';
	import '../../../node_modules/echarts/map/js/province/qinghai.js';
	import '../../../node_modules/echarts/map/js/province/shandong.js';
	import '../../../node_modules/echarts/map/js/province/shanghai.js';
	import '../../../node_modules/echarts/map/js/province/shanxi.js';
	import '../../../node_modules/echarts/map/js/province/shanxi1.js';
	import '../../../node_modules/echarts/map/js/province/sichuan.js';
	import '../../../node_modules/echarts/map/js/province/taiwan.js';
	import '../../../node_modules/echarts/map/js/province/tianjin.js';
	import '../../../node_modules/echarts/map/js/province/xianggang.js';
	import '../../../node_modules/echarts/map/js/province/xinjiang.js';
	import '../../../node_modules/echarts/map/js/province/xizang.js';
	import '../../../node_modules/echarts/map/js/province/yunnan.js';
	import '../../../node_modules/echarts/map/js/province/zhejiang.js';
	import countTo from 'vue-count-to';
	import zongbuImage from "@/assets/icon/xingxing.png";
	import banshichuImage from "@/assets/icon/dibiao.png";
	import flag from "@/assets/icon/flag.png";
	export default {
		components: {
			countTo
		},
		data() {
			return {
				chinaMap: null,
				startVal: 0,
				endVal: 0,
				list: [],
				numList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '.'],
				currtime: '',
				mapType: true,
				echartsType: true,
				seriesList: [{
						name: "运营中心",
						image: zongbuImage,
						data: [{
							name: "浙江",
							value: [120.231075, 30.209885, 1]
						}, {
							name: "湖南",
							value: [113.039202, 28.184893, 1]
						}]
					},
					{
						name: "办事处",
						image: banshichuImage,
						data: [{
								name: "四川",
								value: [104.10194, 30.65984, 2]
							},
							{
								name: "江西",
								value: [115.94422, 28.54538, 2]
							},
							{
								name: "广西",
								value: [108.27331, 22.78121, 2]
							},
							{
								name: "广东",
								value: [113.27324, 23.15792, 2]
							},
							{
								name: "安徽",
								value: [117.30794, 31.79322, 2]
							},
							{
								name: "江苏",
								value: [120.28429, 31.52853, 2]
							},
							{
								name: "江苏",
								value: [118.8735, 33.29433, 2]
							},
							{
								name: "河南",
								value: [113.6401, 34.72468, 2]
							},
							{
								name: "山东",
								value: [116.75199, 36.55358, 2]
							},
							{
								name: "福建",
								value: [119.27345, 26.04769, 2]
							},
							{
								name: "陕西",
								value: [108.93425, 34.23053, 2]
							},
							{
								name: "湖北",
								value: [114.02919, 30.58203, 2]
							}
						]
					}
				],
				buildingSeriesList: [
					{
						name: "区域",
						image: flag,
						data: [{
								name: "浙江",
								value: [120.231075, 30.209885, 1]
							}, 
							{
								name: "湖南",
								value: [113.039202, 28.184893, 1]
							}, 
							{
								name: "四川",
								value: [104.10194, 30.65984, 1]
							},
							{
								name: "江西",
								value: [115.94422, 28.54538, 1]
							},
							{
								name: "广西",
								value: [108.27331, 22.78121, 1]
							},
							{
								name: "广东",
								value: [113.27324, 23.15792, 1]
							},
							{
								name: "安徽",
								value: [117.30794, 31.79322, 1]
							},
							{
								name: "江苏",
								value: [120.28429, 31.52853, 1]
							},
							{
								name: "江苏",
								value: [118.8735, 33.29433, 1]
							},
							{
								name: "河南",
								value: [113.6401, 34.72468, 1]
							},
							{
								name: "山东",
								value: [116.75199, 36.55358, 1]
							},
							{
								name: "福建",
								value: [119.27345, 26.04769, 1]
							},
							{
								name: "陕西",
								value: [108.93425, 34.23053, 1]
							},
							{
								name: "湖北",
								value: [114.02919, 30.58203, 1]
							}
						]
					}
				],
				provinces: ["北京","天津","上海","重庆","新疆","西藏","宁夏","内蒙古","广西","黑龙江","吉林","辽宁","河北","山东","江苏","安徽","浙江","福建","广东","海南","云南","贵州","四川","湖南","湖北","河南","山西","陕西","甘肃","青海","江西","台湾","香港","澳门"]
			};
		},
		props: ['topData', 'geoCoordMap'],
		watch: {
			'topData': {
				handler() {
					this.draw();
					// console.log(this.topData,this.geoCoordMap)
				},
				deep: true
			}
		},
		mounted() {
			this.saveEnergyConsumption()
			this.getTime()
		},
		methods: {
			changeType(bool) {
				this.mapType = bool;
				this.draw()
			},
			async saveEnergyConsumption() {
				await this.$axios.get("/api/buildings/saveEnergyConsumption").then(res => {
					this.endVal = res.data.data.result
					this.list = this.endVal.toString().split('');
					let arr = [];
					this.list.forEach((value) => {
						arr.push({
							num: value,
							top: 0
						})
					});
					this.list = arr;
					let Hei = parseFloat(getComputedStyle(document.getElementById("dataNums")).height);
					this.list.forEach((value, index) => {
						setTimeout(() => {
							value.top = parseFloat((value.num * Hei) + (Hei * 10));
						}, index * 300);
					});
				})
			},
			convertData(data) { //覆盖点的样式
				let res = [];
				for (let i = 0; i < data.length; i++) {
					let geoCoord = this.geoCoordMap.get(data[i].name); //es6map 语法
					if (geoCoord) {
						res.push({
							name: data[i].name,
							id: data[i].id,
							value: geoCoord.concat(data[i].value),
						});
					}
				}
				return res;
			},
			draw() {
				const buildingSeries = this.buildingSeriesList.map((v) => {
					return {
						name: v.name,
						type: "custom",
						coordinateSystem: "geo",
						tooltip: {
							trigger: 'item',
							show: true,
							formatter: function(params) {
								console.log(params)
							}
						},
						renderItem(params, api) {
							return {
								type: "image",
								style: {
									image: v.image,
									text: v.data[params.dataIndex].value[3],
									x: api.coord([
										v.data[params.dataIndex].value[0],
										v.data[params.dataIndex].value[1]
									])[0] - 16,
									y: api.coord([
										v.data[params.dataIndex].value[0],
										v.data[params.dataIndex].value[1]
									])[1] - 16
								},
							};
						},
						data: v.data
					};
				});
				var option = {
					tooltip: { //此处是根据后端数据进行hover 展示的提示框，可用官网上默认的
						trigger: "item",
						formatter: function(params) {
							// console.log(params)
							return params.name + "</br>" + "制冷面积：" + params.data.value[2] + "m²" +
								"</br>" + "制冷体积：" + params.data.value[3] + "m³";
						}
					},
					geo: {
						map: 'china',
						roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
						zoom: 1,
						scaleLimit: {
							min: 1,
							max: 50
						},
						label: {
							show: true,
							color: '#fff',
							fontSize: 13
						},
						itemStyle: {
							normal: {
								areaColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 1,
									y2: 0,
									colorStops: [{
										offset: 0,
										color: '#2A90BC'
									}, {
										offset: 0.5,
										color: '#2A9BC7'
									}],
								},
								shadowColor: `#2A9BC7`,
								shadowOffsetX: 4,
								shadowOffsetY: 8,
								borderColor: `#000`,
								borderWidth: 1,
							},
							emphasis: {
								areaColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 1,
									y2: 0,
									colorStops: [{
										offset: 0,
										color: '#2A9BC7'
									}, {
										offset: 0.5,
										color: '#2AB4C7'
									}],
								}
							},
						}
					},
					series: buildingSeries
					// series: [{
					// 	type: 'effectScatter',
					// 	roam: true,
					// 	coordinateSystem: 'geo',
					// 	rippleEffect: {
					// 		period: 2, //波纹秒数
					// 		brushType: 'stroke', //stroke(涟漪)和fill(扩散)，两种效果
					// 		scale: 1 //波纹范围
					// 	},
					// 	effectType: 'ripple',
					// 	itemStyle: {
					// 		color: '#D8D81A',
					// 		opacity: 0.8
					// 	},
					// 	data: this.convertData(this.topData)
					// }]
				};
				const series = this.seriesList.map((v) => {
					return {
						name: v.name,
						type: "custom",
						coordinateSystem: "geo",
						tooltip: {
							trigger: 'item',
							show: true,
							formatter: function(params) {
								// console.log(params)
							}
						},
						renderItem(params, api) {
							return {
								type: "image",
								style: {
									image: v.image,
									x: api.coord([
										v.data[params.dataIndex].value[0],
										v.data[params.dataIndex].value[1]
									])[0] - 16,
									y: api.coord([
										v.data[params.dataIndex].value[0],
										v.data[params.dataIndex].value[1]
									])[1] - 16
								},
							};
						},
						data: v.data
					};
				});
				let mapOption = {
					tooltip: {
						trigger: "item",
						show: true,
						formatter: function(params) {
							// console.log(params)
						}
					},
					geo: {
						map: "china",
						tooltip: {
							trigger: 'item',
							show: true,
							formatter: function(params) {
								// console.log(params)
							}
						},
						zoom: 1,
						scaleLimit: {
							min: 1,
							max: 10
						},
						roam: true,
						label: {
							show: true,
							color: '#fff',
							fontSize: 13
						},
						itemStyle: {
							normal: {
								areaColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 1,
									y2: 0,
									colorStops: [{
										offset: 0,
										color: '#2A90BC'
									}, {
										offset: 0.5,
										color: '#2A9BC7'
									}],
								},
								shadowColor: `#2A9BC7`,
								shadowOffsetX: 4,
								shadowOffsetY: 8,
								borderColor: `#000`,
								borderWidth: 1,
							},
							emphasis: {
								areaColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 1,
									y2: 0,
									colorStops: [{
										offset: 0,
										color: '#2A9BC7'
									}, {
										offset: 0.5,
										color: '#2AB4C7'
									}],
								}
							},
						},
					},
					series,
				};
				let myChart = this.$echarts.init(document.getElementById('china_map'));

				myChart.clear()
				myChart.off('click')
				let that = this
				if (that.mapType) {
					myChart.setOption(mapOption, true);
				} else {
					myChart.setOption(option, true);
				}
				that.echartsType = true
				myChart.on('click', function(params) {
					// console.log(params)
					if(that.mapType){
						if (params.componentType == "geo") {
							let name = params.name
							const series = that.seriesList.map((v) => {
								// console.log(v.data)
								return {
									name: v.name,
									type: "custom",
									coordinateSystem: "geo",
									tooltip: {
										trigger: 'item',
										show: true,
										formatter: function(params) {
											// console.log(params)
										}
									},
									renderItem(params, api) {
										if(name == v.data[params.dataIndex].name){
											return {
												type: "image",
												style: {
													image: v.image,
													x: api.coord([
														v.data[params.dataIndex].value[0],
														v.data[params.dataIndex].value[1]
													])[0] - 16,
													y: api.coord([
														v.data[params.dataIndex].value[0],
														v.data[params.dataIndex].value[1]
													])[1] - 16
												},
											};
										}else{
											return false
										}
									},
									data: v.data
								};
							});
							// console.log(series)
							let mapOption = {
								geo: {
									map: name,
									roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
									zoom: 1,
									scaleLimit: {
										min: 1,
										max: 10
									},
									label: {
										show: true,
										color: '#fff',
										fontSize: 13
									},
									itemStyle: {
										normal: {
											areaColor: {
												type: 'linear',
												x: 0,
												y: 0,
												x2: 1,
												y2: 0,
												colorStops: [{
													offset: 0,
													color: '#2A90BC'
												}, {
													offset: 0.5,
													color: '#2A9BC7'
												}],
											},
											shadowColor: `#2A9BC7`,
											shadowOffsetX: 4,
											shadowOffsetY: 8,
											borderColor: `#000`,
											borderWidth: 1,
										},
										emphasis: {
											areaColor: {
												type: 'linear',
												x: 0,
												y: 0,
												x2: 1,
												y2: 0,
												colorStops: [{
													offset: 0,
													color: '#2A9BC7'
												}, {
													offset: 0.5,
													color: '#2AB4C7'
												}],
											}
										},
									}
								},
								series
							};
							myChart.clear()
							myChart.off('click')
							myChart.setOption(mapOption, true);
							that.echartsType = false
						}
					}else{
						if (params.componentType == "series") {
							that.$router.push({
								name: 'building',
								params: {
									building: params.data.id,
									buildingName: params.data.name
								}
							});
						}else if(params.componentType == "geo"){
							let name = params.name
							if(that.provinces.indexOf(name)!=-1){
								let selectData = []
								for(let item of that.topData){
									if(item.province.indexOf(name) != -1){
										selectData.push(item)
									}
								}
								console.log(selectData.length)
								var option = {
									tooltip: { 
										trigger: "item",
										formatter: function(params) {
											// console.log(params)
											return params.name + "</br>" + "制冷面积：" + params.data.value[2] + "m²" +
												"</br>" + "制冷体积：" + params.data.value[3] + "m³";
										}
									},
									animation: true,
									geo: {
										map: name,
										roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
										zoom: 1,
										scaleLimit: {
											min: 1,
											max: 10
										},
										label: {
											show: true,
											color: '#fff',
											fontSize: 13
										},
										itemStyle: {
											normal: {
												areaColor: {
													type: 'linear',
													x: 0,
													y: 0,
													x2: 1,
													y2: 0,
													colorStops: [{
														offset: 0,
														color: '#2A90BC'
													}, {
														offset: 0.5,
														color: '#2A9BC7'
													}],
												},
												shadowColor: `#2A9BC7`,
												shadowOffsetX: 4,
												shadowOffsetY: 8,
												borderColor: `#000`,
												borderWidth: 1,
											},
											emphasis: {
												areaColor: {
													type: 'linear',
													x: 0,
													y: 0,
													x2: 1,
													y2: 0,
													colorStops: [{
														offset: 0,
														color: '#2A9BC7'
													}, {
														offset: 0.5,
														color: '#2AB4C7'
													}],
												}
											},
										}
									},
									series: [{
										type: 'effectScatter',
										roam: true,
										coordinateSystem: 'geo',
										rippleEffect: {
											period: 2, //波纹秒数
											brushType: 'stroke', //stroke(涟漪)和fill(扩散)，两种效果
											scale: 1 //波纹范围
										},
										effectType: 'ripple',
										itemStyle: {
											color: '#D8D81A',
											opacity: 0.8
										},
										data: that.convertData(selectData)
									}]
								};
								myChart.clear()
								// myChart.off('click')
								myChart.setOption(option, true);
								that.echartsType = false
							}
						}
					}
				});
			},
			getTime: function() {
				let yy = new Date().getFullYear();
				let mm = new Date().getMonth() + 1;
				let dd = new Date().getDate();
				this.currtime = yy + "年" + mm + "月" + dd + "日";
			},
		}
	}
</script>

<style lang="scss">
	#topCenter {
		height: 9.2625rem;
		width: 11.9125rem;

		.chartBox {
			width: 100%;
			height: 100%;
			position: relative;

			.leftTop {
				padding: 0.25rem;
				color: #fff;
				font-size: 22px;
				position: absolute;
				left: 10px;
				top: 10px;

				p {
					height: 0.4375rem;
				}
				
				.exicon{
					cursor: pointer;
					color: #00E5FF;
				}

				.number {
					// text-align: center;
					height: 0.5rem;

					.showtext {
						height: 0.5rem;
						line-height: 0.5rem;
						float: left;
					}

					ul {
						float: left;
						height: 0.5rem;
						text-align: center;

						li {
							float: left;
							width: 0.4rem;
							height: 0.5rem;
							text-align: center;

							.dataBoc {
								position: relative;
								width: 100%;
								height: 100%;
								overflow: hidden;

								.tt {
									position: absolute;
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
									padding-left: 2px;
									padding-right: 2px;

									span {
										width: 100%;
										height: 100%;
										line-height: 0.5rem;
										float: left;
										// text-align: center;
										background: linear-gradient(#02131F, #127E8E, #02131F) !important;
										border-top: #00E5FF 1px solid;
										border-bottom: #00E5FF 1px solid;
										border-radius: 2px;
										font-size: 26px;
										color: #FFF;
									}
								}
							}
						}
					}
				}
			}

			.leftBottom {
				padding: 0.25rem;
				color: #fff;
				font-size: 16px;
				position: absolute;
				left: 10px;
				bottom: 10px;

				div {
					height: 0.4375rem;

					div {
						display: inline-block;

						p {
							line-height: 0.4375rem;
						}

						img {
							width: 0.3125rem;
							height: 0.3125rem;
							margin-top: 0.125rem;
						}
					}
				}
			}

			.rightTop {
				padding: 0.25rem;
				position: absolute;
				right: 10px;
				top: 10px;

				div {
					width: 1.5rem;
					height: 0.5rem;
					cursor: pointer;
					padding: 0 0.125rem;
					line-height: 0.5rem;
					font-size: 0.19375rem;
					border: 1px solid darkgray;

					img {
						width: 0.25rem;
						height: 0.25rem;
						vertical-align: middle;
					}
				}

				.selectDiv {
					border: 1px solid #47E4E5;
					color: #fff;
				}
			}
		}
	}
</style>
